var map = {
	"./admin/brand/route.js": 1615,
	"./admin/list/route.js": 7126,
	"./admin/login/route.js": 674,
	"./display/main/about/route.js": 9208,
	"./display/main/home/route.js": 9776,
	"./display/main/list/route.js": 3134,
	"./display/main/news/route.js": 4683
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 221;